/**
 * Created by yniran on 12/17/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        lpUtils = require("utils/lpUtils"),
        chatTemplateHelper = require("connection-utils/chatTemplateHelper"),
        chatLineFormatter = require("connection-utils/chatLineFormatter"),
        template = require("connection-templates/chatTab/chatWindowContent.tmpl"),
        SnippetModel = require("connection-models/KPsTab/SnippetModel"),
        KPSnippetView = require("connection-views/KPsTab/KPSnippetView"),
        ChatWindowCoBrowseOfferView = require("connection-views/chatTab/ChatWindowCoBrowseOfferView"),
        ChatWindowContentView = {},

        STARTUP_CLASS = "startup-style";


    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        ChatWindowContentView = Marionette.ItemView.extend({

            className: "chat-content-container browser-scroll light scroll-fixed",
            template: template,
            ui: {
                linesWrapper: ".chat-content-lines-wrapper",
                endedNotificationText: ".ended-notification-text"
            },

            initialize: function (options) {

                this._chatVent = options.chatVent;
                this._lastChatLineId = null;
                this._inChat = false;
                this._endedText = LE.translator.translate("LEConnection.chat.endedMessage");

                this._bindEvents();
            },

            onClose: function () {
                this._lastChatLineId = null;
            },

            _bindEvents: function () {
                this.listenTo(this._chatVent, "cpChatUI::new:lines", this._onNewChatLines);
                this.listenTo(this._chatVent, "chatConnection:state", this._onChatState);
            },

            _onChatState: function (data) {

                if (data.state === CP_CONST.CHAT_STATES.ENDED) {
                    if (this._inChat) {

                        this._inChat = false;
                        this._lastChatLineId = null;
                        this._showEndedNotification();
                    }
                }
                else {
                    this._inChat = true;
                    this.$el.removeClass("ended-notification-showing");
                }
            },

            _showEndedNotification: function () {

                this.$el.toggleClass("ended-notification-showing", true);

                var updatedMessage = this._endedText.replace("{0}", lpUtils.formatDateAsShortTime(new Date()));
                this.ui.endedNotificationText.html(updatedMessage);
            },

            _onNewChatLines: function (lines) {

                logger.debug("received new chat lines to show", "ChatWindowContentView._onNewChatLines", lines);

                if (lines && lines.length > 0) {

                    _.each(lines, function (lineInfo) {

                        if (!lineInfo.rendered) {
                            this._renderChatLine(lineInfo);
                        }
                        else {
                            logger.warn("found line that was already marked as rendered in new chat lines request, this shouldn't happen!", "ChatWindowContentView._onNewChatLines", lineInfo);
                        }
                    }, this);
                }
            },

            _renderChatLine: function (lineInfo) {

                if (this._lastChatLineId === lineInfo.id) { //we have rendered this line before. so need to add to its text lines and update time stamp
                    this._updateExistingLine(lineInfo);
                }
                else {
                    this._insertNewLine(lineInfo);
                }

                lineInfo.rendered = true;
            },

            _insertNewLine: function (lineInfo) {

                if(lineInfo.serviceID){
                    this._insertCoBrowseInvitationToContent(lineInfo);

                } else if (lineInfo.text.length > 0) {

                    if (lineInfo.snippet) { //this is a snippet - need to show it as an item and not as a chat line
                        logger.debug("about to render content snippet into chat content ", "ChatWindowContentView._insertNewLine", lineInfo);
                        this._insertSnippetsToContent(lineInfo);
                    } else {
                        this._insertBubbleToContent(lineInfo);
                    }

                    this._scrollToBottom();

                    var lineHtml = this._getLineHtmlById(lineInfo.id);
                    lineHtml.removeClass(STARTUP_CLASS);//kick-off the fade-in transition effect

                    this._lastChatLineId = lineInfo.id;
                }
                else {
                    logger.warn("new line has no text !!! ", "ChatWindowContentView._insertNewLine", lineInfo);
                }
            },

            _insertBubbleToContent: function (lineInfo) {
                var html = chatTemplateHelper.getBubbleHtml(lineInfo);

                if (html) {
                    var $node = this._createHtmlNode(html);
                    this.ui.linesWrapper.append($node);
                }
            },

            /**
             *   render the snippet - should be wrapped in a div with attribute data-lineId = the line id (lineInfo.id),
             *   should also have the 'startup-style' class for the fade in effect
             *   wrap snippetsHtml with div to insert the snippet views into (with the data-lineId and startup class)
             *   use this to add to the UI:  this.ui.linesWrapper.append(wrapper);
             * @param lineInfo
             * @private
             */
            _insertSnippetsToContent: function (lineInfo) {

                _.each(lineInfo.text, function (snippet) {
                    var snippetModelAttrs = {"content": snippet, "slug": snippet.slug};
                    var snippetModel = new SnippetModel(_.extend(snippetModelAttrs, snippet));
                    var wrapper = $("<div/>").addClass("snippet-container " + STARTUP_CLASS).attr({"data-lineId": lineInfo.id});

                    var kpSnippetView = new KPSnippetView({
                        model: snippetModel,
                        el: wrapper,
                        type: CP_CONST.REFERER_ACTION.CANNED_RESPONSE,
                        permutation: CP_CONST.SNIPPET_PERMUTATION.CHAT
                    });


                    kpSnippetView.render();
                    this.ui.linesWrapper.append(wrapper);
                }, this);
            },

            _insertCoBrowseInvitationToContent: function (lineInfo){
                var wrapper = $("<div/>").addClass("cobrowse-container chat-bubble clear").attr({"data-lineId": lineInfo.id});

                var chatWindowCoBrowseOfferView = new ChatWindowCoBrowseOfferView({
                    el: wrapper,
                    serviceID: lineInfo.serviceID,
                    chatVent: this._chatVent
                });


                chatWindowCoBrowseOfferView.render();
                this.ui.linesWrapper.append(wrapper);
            },

            _updateExistingLine: function (lineInfo) {

                var existingLine = this._getLineHtmlById(lineInfo.id);

                if (existingLine && existingLine.size() > 0) {
                    var existingLineGroup = existingLine.find(".chat-bubble-line-group");
                    var existingTime = existingLine.find(".chat-bubble-time");

                    if (existingLineGroup && existingLineGroup.size() > 0) {

                        var html = chatTemplateHelper.getBubbleLinesHtml(lineInfo);

                        if (html) {
                            var $node = this._createHtmlNode(html);

                            existingLineGroup.append($node);
                            this._scrollToBottom();
                            existingLineGroup.find(".chat-bubble-line").removeClass(STARTUP_CLASS); //kick-off the fade-in transition effect
                        }
                    }

                    if (existingTime && existingTime.size() > 0) {
                        existingTime.text(lineInfo.displayTime);
                    }
                }
            },

            _createHtmlNode: function (htmlText) {

                var $node = $(htmlText);

                $node = chatLineFormatter.formatLinks($node); //add _target to all links - doing this here because I dont want to create dom objects twice

                return $node;
            },

            _scrollToBottom: function () {
                this.el.scrollTop = this.el.scrollHeight;
            },

            _getLineHtmlById: function (id) {
                return this.ui.linesWrapper.find("[data-lineId='" + id + "']");
            }
        });
    });

    return ChatWindowContentView;
});